import styled from "styled-components";
import { DESKTOP } from "common/constants/breakpoints";

export default styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 1;
  outline: none;
  border: none;
  cursor: normal;
  background-color: #306ba5;
  color: #ffffff;
  font-size: 16px;
  font-weight: 400;
  padding: 12px 24px;

  &:hover {
    background: #4b86c0;
  }

  &:active {
    background: #1a5690;
  }

  @media screen and (min-width: ${DESKTOP}px) {
    cursor: pointer;
  }
`;
